/*
 * @Description: 白名单
 */

export const whiteList:Array<string> = [
    // 门户布局
    '/portalPage',
    // 门户首页
    '/portalPage/Home',
    // 门户课程广场
    '/portalPage/CoursePlaza',
    // 门户课程详情
    '/portalPage/CourseDetail',
    // 门户文章详情
    '/portalPage/ArticleDetail',
    // 门户所有文章列表
    '/portalPage/AllArticle',
    //登录入口
    '/login',
    //学校迁移交割拦截页
    '/migration'
]
//门户tabs白名单
export const computerPageList:Array<string> = [
    '/computer/construction/pageList',
    '/computer/construction/navBarSetting',
    '/computer/construction/footerSetting',
    '/computer/construction/pageStyle',
]

//不需要重复提交验证的接口
export const repetitionApiList:Array<string> = [
    // '/bigdata/performance/detail' //获取卡片指标
]

